export function Spinner() {
	return <div className='loader'></div>
}
